import { SignInForm } from '../SignInForm/SignInForm.component';
import { LoginProps } from 'pages/connexion';
import React, { ComponentPropsWithRef, FC } from 'react';
import { PlcMessage } from '@components/PlcMessage/PlcMessage.component';
import { Text } from '@components/Text/Text.component';
import { PlcPageHeader } from '@layout/components/PlcPageHeader/PlcPageHeader.component';
import { Breakpoint, useIsBreakpointDown } from '@styles/breakpoints';
import { ApiStatusCode } from '@utils/api.utils';
import classnames from 'classnames';

type Props = ComponentPropsWithRef<'main'> & LoginProps;

function buildMessageFromStatusCode(activationStatusCode: number) {
  if (activationStatusCode === ApiStatusCode.accepted) {
    return 'auth.sign-up.confirmation.success';
  }
  if (activationStatusCode === ApiStatusCode.badRequest) {
    return 'auth.sign-in.link.or.token.invalid';
  }
  if (activationStatusCode === ApiStatusCode.forbidden) {
    return 'auth.sign-up.confirmation.already-done';
  }

  return 'auth.sign-up.confirmation.generic-error';
}

const LoginLayout: FC<Props> = ({ className, activationStatusCode, callbackUrl, ...rest }) => {
  const rootClass = classnames('plc-page', className);
  const isMobile = useIsBreakpointDown(Breakpoint.m);
  return (
    <main className={rootClass} {...rest}>
      <PlcPageHeader heroImgSrc="connexion" i18nTitle="auth.sign-in.page.title" />

      <section className="wrapper-s main-section">
        {activationStatusCode !== undefined && (
          <PlcMessage
            className="plc-paragraph"
            flavour={
              activationStatusCode === ApiStatusCode.accepted || activationStatusCode === ApiStatusCode.forbidden
                ? 'green'
                : 'red'
            }
            i18nKey={buildMessageFromStatusCode(activationStatusCode)}
          />
        )}
        <Text className="plc-paragraph" i18nKey="auth.sign-in.title" variant="h5" />
        <SignInForm callbackUrl={callbackUrl} className="plc-paragraph" isInline wide={!isMobile} />
      </section>
    </main>
  );
};

export { LoginLayout };
